<template>
	<div class="bind_frm">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">解绑FRM</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			取消终端当前项目、人员组的绑定关系。解绑后，本地同步的人员数据将会删除。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">void __stdcall SKFaceUnbindFrm(SKFaceUnbindFrmCallback funcUnbindFRMCallback);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">funcUnbindFRMCallback：解绑FRM的结果回调接口</p>
        
        <h3 class="doc_main_h3">回调值</h3>
        <p class="doc_main_p">
        	funcUnbindFRMCallback类型为 typedef void(__stdcall *SKFaceUnbindFrmCallback) (int nCode, const char *pszMsg) , nCode错误码，0为成功，其他失败；pszMsg：错误消息。
		</p>
		<h3 class="doc_main_h3">错误码列表</h3>
		<get-frm-bind-code-error-list :propsTableData="errorCodeList"></get-frm-bind-code-error-list>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">// 解绑FRM回调函数
void FuncUnbindFrm(int nCode, const char *pszMsg)
{
    printf("UnbindFrmCallback: code=%d, msg=%s\n", nCode, pszMsg);
}
// 解绑FRM
SKFaceUnbindFrm(FuncUnbindFrm);</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import GetFRMBindCodeErrorList from '../../../../components/getFRMBindCodeErrorList';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'get-frm-bind-code-error-list':GetFRMBindCodeErrorList,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Windows','FRM接口','解绑FRM'],
				errorCodeList:[
					{"code":"0","msg":"成功"},
					{"code":"10004","msg":"终端未绑定项目"},
					{"code":"20004","msg":"网络请求失败"},
					{"code":"20005","msg":"网络请求失败"},
					{"code":"20006","msg":"网络请求失败"},
					{"code":"20022","msg":"网络请求失败"},
					{"code":"20024","msg":"网络请求失败"},
					
				]
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.bind_frm{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacewindows/frm/untyingFRM.vue